import { useEffect } from "react";

interface PageMetaOptions {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

export function usePageMeta({ title, description, keywords, canonical }: PageMetaOptions) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }

    if (keywords) {
      setMeta("keywords", keywords);
    }

    setMeta("og:title", title, "property");
    setMeta("twitter:title", title);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    const lastModified = document.querySelector('meta[name="last-modified"]') as HTMLMetaElement | null;
    if (lastModified) {
      lastModified.setAttribute("content", new Date().toISOString().split("T")[0]);
    }
  }, [title, description, keywords, canonical]);
}